/* House of Dhatu — collection card set picker.
   Keeps the Buy now form, the Add to cart form and the displayed price in sync
   with whichever set pill is selected. GoKwik reads the variant from the
   closest <form> that has a [name="id"] input, so updating those inputs is all
   that is needed for Buy now to check out the right set. */
(function () {
  if (window.customElements && customElements.get('dhatu-card-buy')) return;

  class DhatuCardBuy extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.addEventListener('change', this._onChange.bind(this));
    }

    _onChange(event) {
      const radio = event.target;
      if (!radio || radio.type !== 'radio' || !radio.hasAttribute('data-dh-variant')) return;
      this.select(radio.value);
    }

    select(variantId) {
      this.querySelectorAll('[data-dh-id]').forEach(function (input) {
        input.value = variantId;
      });

      const uid = this.getAttribute('data-uid');
      if (!uid) return;

      const priceEls = document.querySelectorAll('.dh-cardprice');
      for (let i = 0; i < priceEls.length; i++) {
        if (priceEls[i].getAttribute('data-uid') !== uid) continue;
        priceEls[i].querySelectorAll('[data-vid]').forEach(function (node) {
          node.hidden = node.getAttribute('data-vid') !== variantId;
        });
      }
    }
  }

  customElements.define('dhatu-card-buy', DhatuCardBuy);
})();
